

export function updateFilterUrl(activeFilters, currentPage, filterView) {
  let filterUrl = '';
  let count = 0;
  for (const filter_name in activeFilters) {
    const filter = activeFilters[filter_name],
      filter_values = filter.value.toString();

    if (filter_values.length) {
      if (count > 0) {
        filterUrl += '&';
      } else {
        filterUrl += '#';
      }
      filterUrl += filter_name + '=' + filter_values;

      count += 1;

    }
  }
  if (count > 0) {
    filterUrl += '&page=' + currentPage;
    filterUrl += '&view=' + filterView;

  } else {
    filterUrl += '#page=' + currentPage;
    filterUrl += '&view=' + filterView;
  }
  window.history.pushState(null, null, filterUrl);
}


export function parseFilterUrl(filterForm, filterSettings, topFilter) {

  const hash = window.location.hash;


  filterForm.forEach((widget) => {
    widget.filters.forEach((filter) => {

      const activeFilter = {
        position: 'side',
        type: filter.type,
        name: filter.name,
        title: filter.title,
        value: filter.name === "search" ? "" : [],
        selectedTitles: [],
        or: filter.or
      }
      filterSettings.activeFilters[filter.name] = activeFilter;
    })
  });


  //hard coded removes the need for a widget added to youcreate

  if (filterSettings.calendarViewEnabled) {

    if (typeof filterSettings.activeFilters.calendar === "undefined") {
      const calendar_filter =
      {
        type: "date",
        name: "calendar",
        title: "Calendar",
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(0, 0, 0, 0))],
        or: false,
      };
      filterSettings.activeFilters["calendar"] = calendar_filter;
    } else {
      filterSettings.activeFilters.calendar.value = [new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(0, 0, 0, 0))];
    }
  }



  if (typeof topFilter !== "undefined") {
    filterSettings.activeFilters["top_filter"] = topFilter;
  }


  if (!hash.length)
    return filterSettings;

  const params = hash.split("#")[1].split("&");
  params.forEach((param, i) => {
    const v = param.split("=");
    if (v[0] === "page") {
      filterSettings.pagination.currentPage = v[1];
    } else if (v[0] === "view") {
      filterSettings.currentView = v[1];
    } else {

      if (filterSettings.activeFilters[v[0]]) {
        let value = [];
        value = v[1].split(',');
        if (v[0] === "search" || v[0] === "calendar" || v[0] === "time") {
          value = decodeURI(v[1]);
          filterSettings.activeFilters[v[0]].value = value;

        } else if (v[0] === "top_filter") {
          if (filterSettings.activeFilters[v[0]].type === "date" && v[1] !== "all") {
            filterSettings.activeFilters[v[0]].value = parseInt(v[1]);
          } else {
            filterSettings.activeFilters[v[0]].value = v[1];
          }

        } else {

          filterSettings.activeFilters[v[0]].value = value;
          //need to do it this way to maintain correct order. will need to be optimised
          const selectedTitles = [];
          if (typeof value !== "undefined") {
            value.forEach((v) => {

              filterForm.forEach((widget) => {
                if (typeof widget.filters !== "undefined") {
                  const filters = widget.filters;

                  filters.forEach((filter) => {

                    if (typeof filter.elements !== "undefined" && filter.elements.length) {
                      const elements = filter.elements;
                      elements.forEach((element) => {
                        if (v === element.value) {
                          selectedTitles.push(element.title);

                        }
                      })
                    }


                  })
                }

              })
            })
          }


          filterSettings.activeFilters[v[0]].selectedTitles = selectedTitles;
        }




      }

    }
  });
  return filterSettings;
}
